import { ICex, IDex } from './models';

import { AApiBase } from '../apiBase/AApiBase';
import type { IBaseResponse } from '../apiBase/IBaseResponse';
import { mapError } from '../apiBase/mapError';
import { mapResponse } from '../apiBase/mapResponse';

class ApiDictionary extends AApiBase {
  protected baseUrl = '/api';
  protected withHeader = true;

  private static __instance: ApiDictionary | undefined;
  private static get instance(): ApiDictionary {
    if (ApiDictionary.__instance === undefined) {
      ApiDictionary.__instance = new ApiDictionary();
    }
    return ApiDictionary.__instance;
  }

  public static getDexs = async () => {
    try {
      const response = await ApiDictionary.instance.get<IBaseResponse<{ items: IDex[] }>>('/dexs');

      return mapResponse({
        data: response.data,
      });
    } catch (error: unknown) {
      return mapError<{ items: IDex[] }>({ error });
    }
  };

  public static getCexs = async () => {
    try {
      const response = await ApiDictionary.instance.get<IBaseResponse<{ items: ICex[] }>>('/cexs');

      return mapResponse({
        data: response.data,
      });
    } catch (error: unknown) {
      return mapError<{ items: ICex[] }>({ error });
    }
  };
}

export { ApiDictionary };
